export const fleamarket = {
  /** 一覧画面の見出し */
  title: "フリマ",
  /** coco+ はフリマを「出品」と呼ぶ */
  cocoplusTitle: "出品",
  purchase: {
    actionName: "商品購入",
  },
  receipt: {
    notDelivered:
      "まだ商品が配達されていません。配達完了後にもう一度お試しください",
    notShipped:
      "発送手続きがまだ完了していません。出品者の発送をお待ちください",
    maintenance:
      "ただいま配送システムがメンテナンス中です。時間をおいてお試しください",
    statusUnavailable:
      "配送状況を確認できませんでした。時間をおいてお試しください",
    failed: "受け取り確認に失敗しました",
    checkingDelivery: "配送状況を確認しています…",
    waitingDelivery: "配達が完了すると、受け取りボタンを押せるようになります。",
    arrivedHint: "商品が到着したら、受け取りボタンを押してください。",
  },
} as const;
